export default __webpack_public_path__ + "static/media/product-feedback-survey.2a44c609.png";